import "./order.a5c88637.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire305e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire305e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $03cFT = parcelRequire("03cFT");

var $ekwLD = parcelRequire("ekwLD");

var $cxph1 = parcelRequire("cxph1");

var $3w2h1 = parcelRequire("3w2h1");

(parcelRequire("8vghX")).config();
"use strict";
window.Webflow ||= [];
window.Webflow.push(async ()=>{
    // MARK: - ELEMENTS
    const progressModal = document.getElementById('progressModal');
    const deliveryButton = document.getElementById("orderDeliveryButton");
    const pickUpButton = document.getElementById("orderPickUpButton");
    const deliverySection = document.getElementById("orderDeliverySection");
    const pickUpSection = document.getElementById("orderPickUpSection");
    const pickUpZipcodeField = document.getElementById("orderPickupZipcodeField");
    const pickUpFormButton = document.getElementById("orderPickupFormButton");
    const deliveryAddressField = document.getElementById("orderDeliveryAddressField");
    const deliveryAptField = document.getElementById("orderDeliveryAptField");
    const deliveryZipcodeField = document.getElementById("orderDeliveryZipcodeField");
    const deliveryCityField = document.getElementById("orderDeliveryCityField");
    const deliveryStateField = document.getElementById("orderDeliveryStateField");
    const deliveryInstructionsField = document.getElementById("deliveryInstructionsField");
    const deliveryFormButton = document.getElementById("orderDeliveryFormButton");
    const addressesDiv = document.getElementById("addressesDiv");
    const otherAddressDiv = document.getElementById("otherAddressDiv");
    const otherAddressIcon = document.getElementById("otherAddressIcon");
    const saveAddressDiv = document.getElementById("saveAddressDiv");
    const saveAddressIcon = document.getElementById("saveAddressIcon");
    const selectedDeliveryButtonDiv = document.getElementById("selectedDeliveryButtonDiv");
    const continueDeliveryButtom = document.getElementById("continueDeliveryButtom");
    var deliveryAddress;
    var selectedAddress;
    var saveAddress = false;
    // MARK: - DISABLE FORMS
    $("#wf-form-Pick-Up-Address-Form").submit(()=>{
        return false;
    });
    $("#form-delivery-address").submit(()=>{
        return false;
    });
    // MARK: - SET UP
    function setUpPage() {
        const pickUpAddress = JSON.parse(sessionStorage.getItem('pickupAddress'));
        if (pickUpAddress != null) pickUpZipcodeField.value = pickUpAddress.postalCode;
        const currentUser = (0, $03cFT.default).User.current();
        if (currentUser == null || currentUser.get('anonymous') == true) {
            const deliveryAddress = JSON.parse(sessionStorage.getItem('deliveryAddress'));
            if (deliveryAddress != null) setDeliveryFields(deliveryAddress);
        }
        const startDelivery = JSON.parse(sessionStorage.getItem('startDelivery'));
        if (startDelivery != null) {
            if (startDelivery == true) showDeliveryForm();
            else showPickUpForm();
        }
        const deliveryBool = JSON.parse(sessionStorage.getItem('deliveryBool'));
        if (deliveryBool != null) {
            if (deliveryBool) showDeliveryForm();
            else showPickUpForm();
        }
    }
    var addresses = [];
    async function showDeliveryForm() {
        deliveryButton.style.backgroundColor = '#000000';
        deliveryButton.style.color = 'white';
        //deliveryButton.style.border = "1px solid black";
        pickUpButton.style.backgroundColor = 'white';
        pickUpButton.style.color = 'black';
        //pickUpButton.style.border = "3px solid black";
        pickUpSection.style.display = 'none';
        const currentUser = (0, $03cFT.default).User.current();
        if (currentUser != null && currentUser.get('anonymous') == false) {
            saveAddressDiv.style.display = 'flex';
            progressModal.style.display = 'flex';
            clearAddressCells();
            addresses = await (0, $03cFT.default).Cloud.run('loadUserAddresses', {});
            if (addresses.length == 0) {
                deliverySection.style.display = 'block';
                deliveryAddressField.focus();
            } else {
                setUpAddressTable();
                addressesDiv.style.display = 'block';
                selectedDeliveryButtonDiv.style.display = 'flex';
                otherAddressDiv.style.display = 'flex';
            }
            progressModal.style.display = 'none';
        } else {
            saveAddressDiv.style.display = 'none';
            deliverySection.style.display = 'block';
            deliveryAddressField.focus();
        }
    }
    function setUpAddressTable() {
        const addressCell = document.querySelector('[address="cell"]');
        const addressParent = addressCell.parentNode;
        const addressCells = [
            ...document.querySelectorAll('[address="cell"]')
        ];
        for(let i = 0; i < addresses.length; i++){
            const newAddressCell = i === 0 ? addressCells[0] : addressCells[0].cloneNode(true);
            const address = addresses[i];
            const selectIcon = newAddressCell.querySelector('[address="selectIcon"]');
            const deliveryAddress = JSON.parse(sessionStorage.getItem('deliveryAddress'));
            if (deliveryAddress != null) {
                if (deliveryAddress.id == address.id) selectIcon.src = 'https://cdn.prod.website-files.com/69844dfbb2540a64ede3d866/69844dfbb2540a64ede3d8bd_6471bc91943c57da4b62374c873a7626_radio-button-selected.png';
                else selectIcon.src = 'https://cdn.prod.website-files.com/674a9e2494fe039046e5bde6/675a12ce243a44d1eee4ad81_radio-button.png';
            }
            /*
            const defaultAddress = address.get('default');
            if (defaultAddress == true) {
                selectIcon.src = 'https://cdn.prod.website-files.com/69844dfbb2540a64ede3d866/69844dfbb2540a64ede3d8bd_6471bc91943c57da4b62374c873a7626_radio-button-selected.png';
            } else {
                selectIcon.src = 'https://cdn.prod.website-files.com/674a9e2494fe039046e5bde6/675a12ce243a44d1eee4ad81_radio-button.png';
            }*/ const infoLabel = newAddressCell.querySelector('[address="infoLabel"]');
            const addressText = address.get('address').toUpperCase();
            const city = address.get('city').toUpperCase();
            const state = address.get('state').toUpperCase();
            const zipcode = address.get('zipcode');
            infoLabel.innerText = addressText + '\n' + city + ', ' + state + ' ' + zipcode;
            // instructionsLabel
            const instructionsLabel = newAddressCell.querySelector('[address="instructionsLabel"]');
            const instructions = address.get('instructions');
            if (instructions != null && instructions != 'none') {
                instructionsLabel.innerText = instructions;
                instructionsLabel.style.display = 'block';
            } else instructionsLabel.style.display = 'none';
            const editButton = newAddressCell.querySelector('[address="editButton"]');
            editButton.addEventListener('click', ()=>{
                existingAddress = address;
                addressTopLabel.innerText = 'UPDATE ADDRESS';
                addressExplainLabel.innerText = 'EDIT EXISTING ADDRESS';
                setAddressFields(address);
                addressModal.style.display = 'flex';
            });
            const clickable = newAddressCell.querySelector('[address="clickableCell"]');
            clickable.addEventListener('click', ()=>{
                clearSelectIcons();
                deliverySection.style.display = 'none';
                selectedDeliveryButtonDiv.style.display = 'flex';
                selectedAddress = address;
                selectIcon.src = 'https://cdn.prod.website-files.com/69844dfbb2540a64ede3d866/69844dfbb2540a64ede3d8bd_6471bc91943c57da4b62374c873a7626_radio-button-selected.png';
            });
            addressParent.appendChild(newAddressCell);
        }
    }
    otherAddressDiv.addEventListener('click', ()=>{
        clearSelectIcons();
        selectedAddress = null;
        otherAddressIcon.src = 'https://cdn.prod.website-files.com/69844dfbb2540a64ede3d866/69844dfbb2540a64ede3d8bd_6471bc91943c57da4b62374c873a7626_radio-button-selected.png';
        selectedDeliveryButtonDiv.style.display = 'none';
        deliverySection.style.display = 'block';
        deliveryAddressField.focus();
    });
    saveAddressDiv.addEventListener('click', ()=>{
        saveAddress = !saveAddress;
        if (saveAddress == true) saveAddressIcon.src = 'https://cdn.prod.website-files.com/69844dfbb2540a64ede3d866/69844dfbb2540a64ede3d8bd_6471bc91943c57da4b62374c873a7626_radio-button-selected.png';
        else saveAddressIcon.src = 'https://cdn.prod.website-files.com/674a9e2494fe039046e5bde6/675a12ce243a44d1eee4ad81_radio-button.png';
    });
    function clearAddressCells() {
        const cells = [
            ...document.querySelectorAll('[address="cell"]')
        ];
        var index = 0;
        for (const cell of cells){
            if (index != 0) cell.remove();
            index += 1;
        }
    }
    function clearSelectIcons() {
        const addressCells = [
            ...document.querySelectorAll('[address="cell"]')
        ];
        for (const cell of addressCells){
            const selectIcon = cell.querySelector('[address="selectIcon"]');
            selectIcon.src = 'https://cdn.prod.website-files.com/674a9e2494fe039046e5bde6/675a12ce243a44d1eee4ad81_radio-button.png';
        }
        otherAddressIcon.src = 'https://cdn.prod.website-files.com/674a9e2494fe039046e5bde6/675a12ce243a44d1eee4ad81_radio-button.png';
    }
    function showPickUpForm() {
        deliveryButton.style.backgroundColor = 'white';
        deliveryButton.style.color = 'black';
        //deliveryButton.style.border = "3px solid black";
        pickUpButton.style.backgroundColor = '#000000';
        pickUpButton.style.color = 'white';
        //pickUpButton.style.border = "1px solid black";
        deliverySection.style.display = 'none';
        addressesDiv.style.display = 'none';
        selectedDeliveryButtonDiv.style.display = 'none';
        otherAddressDiv.style.display = 'none';
        pickUpSection.style.display = 'block';
        pickUpZipcodeField.focus();
    }
    // MARK: - VERIFY ADDRESS
    async function validateAddress(addressText) {
        (0, $ekwLD.default).initialize("prj_live_pk_f7099f165883e6e33410b334bfea0419b2b248f2");
        const addressJson = await (0, $ekwLD.default).forwardGeocode({
            query: addressText
        });
        const address = addressJson.addresses[0];
        return address;
    }
    // MARK: - BUTTON ACTIONS
    deliveryButton.addEventListener('click', ()=>{
        showDeliveryForm();
    });
    pickUpButton.addEventListener('click', ()=>{
        showPickUpForm();
    });
    // MARK: - DELIVERY FORM
    continueDeliveryButtom.addEventListener('click', async ()=>{
        if (selectedAddress != null) {
            // Continue with already saved address
            const addressText = selectedAddress.get('address');
            const apt = selectedAddress.get('apt');
            const zipcodeText = selectedAddress.get('zipcode');
            const cityText = selectedAddress.get('city');
            const stateText = selectedAddress.get('state');
            const geopoint = selectedAddress.get('location');
            const instructions = selectedAddress.get('instructions');
            deliveryAddress = {
                'addressLabel': addressText,
                'postalCode': zipcodeText,
                'city': cityText,
                'stateCode': stateText,
                'id': selectedAddress.id,
                'instructions': instructions
            };
            if (geopoint != null) {
                deliveryAddress.latitude = geopoint.latitude;
                deliveryAddress.longitude = geopoint.longitude;
            }
            if (apt != 'none') deliveryAddress.apt = apt;
        }
        const addressText = deliveryAddress.addressLabel;
        const cityText = deliveryAddress.city;
        const stateText = deliveryAddress.stateCode;
        const zipcodeText = deliveryAddress.postalCode;
        const apt = deliveryAddress.apt;
        const instructions = deliveryAddress.instructions;
        sendDeliveryAddress(addressText, cityText, stateText, zipcodeText, apt, instructions);
    });
    deliveryFormButton.addEventListener('click', async ()=>{
        const addressText = deliveryAddressField.value;
        const zipcodeText = deliveryZipcodeField.value;
        const cityText = deliveryCityField.value;
        const stateText = deliveryStateField.value;
        const instructions = deliveryInstructionsField.value;
        const apt = deliveryAptField.value;
        const error = checkAddressInput(addressText, zipcodeText, cityText, stateText);
        if (error != "") alert(error);
        else sendDeliveryAddress(addressText, cityText, stateText, zipcodeText, apt, instructions);
    });
    async function sendDeliveryAddress(addressText, cityText, stateText, zipcodeText, apt, instructions) {
        progressModal.style.display = 'flex';
        const request = {
            "addressText": addressText,
            "cityText": cityText,
            "stateText": stateText,
            "zipcodeText": zipcodeText,
            "apt": apt,
            "instructions": instructions,
            "saveAddress": saveAddress,
            "device": "web"
        };
        try {
            const response = await (0, $03cFT.default).Cloud.run('verifyAddressRadar', request);
            deliveryAddress = response.deliveryAddress;
            const deliveryLocation = response.deliveryLocation;
            const locationObject = {
                id: deliveryLocation.id,
                city: deliveryLocation.get('city'),
                address: deliveryLocation.get('address'),
                state: deliveryLocation.get('state'),
                zipcode: '' + deliveryLocation.get('zipcode'),
                phone: deliveryLocation.get('phonenumber')
            };
            localStorage.setItem('location', JSON.stringify(locationObject));
            sessionStorage.setItem('deliveryAddress', JSON.stringify(deliveryAddress));
            sessionStorage.setItem('deliveryBool', 'true');
            const restaurantGuid = deliveryLocation.get('guid');
            const toastLocation = await (0, $03cFT.default).Cloud.run('getToastLocation', {
                'restaurantGuid': restaurantGuid
            });
            localStorage.setItem('toastLocation', JSON.stringify(toastLocation.get('object')));
            const toastOrderSchedule = await (0, $03cFT.default).Cloud.run('getToastOrderSchedule', {
                'restaurantGuid': restaurantGuid
            });
            localStorage.setItem('toastOrderSchedule', JSON.stringify(toastOrderSchedule.get('object')));
            const parseMenu = await (0, $03cFT.default).Cloud.run('loadToastMenu', {
                'restaurantGuid': restaurantGuid
            });
            const toastMenuObject = parseMenu.get('object');
            (0, $3w2h1.storeMenuData)(toastMenuObject);
            const currentUser = (0, $03cFT.default).User.current();
            if (currentUser != null) {
                const stock = await (0, $03cFT.default).Cloud.run('loadToastStock', {
                    'restaurantGuid': restaurantGuid
                });
                const stocks = stock.get('objects');
                const removeIndexes = (0, $3w2h1.removeUnavailableItems)(stocks);
                if (removeIndexes.length > 0) {
                    removeIndexes.sort(function(a, b) {
                        return b - a;
                    });
                    await (0, $03cFT.default).Cloud.run('removeToastSelections', {
                        'indexes': removeIndexes,
                        'locationid': deliveryLocation.id
                    });
                    alert("Unavailable items have been removed from your box");
                }
            }
            (0, $cxph1.goToNextPage)('/menu');
        } catch (e) {
            alert(e.message);
            return;
        }
        progressModal.style.display = 'none';
    }
    deliveryZipcodeField.addEventListener('input', async (e)=>{
        const zipcodeText = e.target.value;
        if (zipcodeText.length > 5) e.target.value = zipcodeText.substring(0, 5);
        if (zipcodeText.length === 5) {
            const addressText = deliveryAddressField.value;
            if (addressText != null) {
                progressModal.style.display = 'flex';
                try {
                    deliveryAddress = await validateAddress(addressText + ' ' + zipcodeText);
                    const apt = deliveryAptField.value;
                    deliveryAddress.apt = apt;
                    setDeliveryFields(deliveryAddress);
                } catch (e) {
                    alert('Invalid address' + e.message);
                }
                progressModal.style.display = 'none';
            }
        }
    });
    function setDeliveryFields(deliveryAddress) {
        deliveryAddressField.value = deliveryAddress.addressLabel;
        deliveryZipcodeField.value = deliveryAddress.postalCode;
        deliveryCityField.value = deliveryAddress.city;
        deliveryStateField.value = deliveryAddress.stateCode;
        deliveryAptField.value = deliveryAddress.apt;
        const instructions = deliveryAddress.instructions;
        if (instructions != null && instructions != 'none') deliveryInstructionsField.value = instructions;
    }
    // MARK: - EDIT ADDRESS
    const addressModal = document.getElementById('addressModal');
    const addressTopLabel = document.getElementById('addressTopLabel');
    const addressExplainLabel = document.getElementById('addressExplainLabel');
    const addressTextField = document.getElementById('addressTextField');
    const aptTextField = document.getElementById('aptTextField');
    const zipcodeTextField = document.getElementById('zipcodeTextField');
    const cityTextField = document.getElementById('cityTextField');
    const stateTextField = document.getElementById('stateTextField');
    const instructionsTextField = document.getElementById('instructionsTextField');
    const saveAddressButton = document.getElementById('saveAddressButton');
    $("#addressForm").submit(()=>{
        return false;
    });
    var existingAddress;
    var editDeliveryAddress;
    function setAddressFields(address) {
        addressTextField.value = address.get('address');
        const apt = address.get('apt');
        aptTextField.value = '';
        if (apt != null && apt != 'none') aptTextField.value = apt;
        zipcodeTextField.value = address.get('zipcode');
        cityTextField.value = address.get('city');
        stateTextField.value = address.get('state');
        const instructions = address.get('instructions');
        if (instructions != null && instructions != "none") instructionsTextField.value = instructions;
        else instructionsTextField.value = '';
    }
    function clearAddressTextFields() {
        existingAddress = null;
        editDeliveryAddress = null;
        addressTextField.value = '';
        aptTextField.value = '';
        zipcodeTextField.value = '';
        cityTextField.value = '';
        stateTextField.value = '';
        instructionsTextField.value = '';
    }
    zipcodeTextField.addEventListener('input', async (e)=>{
        const zipcodeText = e.target.value;
        if (zipcodeText.length > 5) e.target.value = zipcodeText.substring(0, 5);
        if (zipcodeText.length === 5) {
            const addressText = addressTextField.value;
            if (addressText != null) {
                progressModal.style.display = 'flex';
                try {
                    editDeliveryAddress = await validateAddress(addressText + ' ' + zipcodeText);
                    const apt = aptTextField.value;
                    editDeliveryAddress.apt = apt;
                    setEditDeliveryFields(editDeliveryAddress);
                } catch (e) {
                    alert('Invalid address' + e.message);
                }
                progressModal.style.display = 'none';
            }
        }
    });
    function setEditDeliveryFields(deliveryAddress) {
        addressTextField.value = deliveryAddress.addressLabel;
        zipcodeTextField.value = deliveryAddress.postalCode;
        cityTextField.value = deliveryAddress.city;
        stateTextField.value = deliveryAddress.stateCode;
        aptTextField.value = deliveryAddress.apt;
    }
    saveAddressButton.addEventListener('click', async ()=>{
        const address = addressTextField.value;
        const apt = aptTextField.value;
        const zipcode = zipcodeTextField.value;
        const city = cityTextField.value;
        const state = stateTextField.value;
        const error = checkAddressInput(address, zipcode, city, state);
        if (error == '') {
            progressModal.style.display = 'flex';
            try {
                const addressText = address + ', ' + city + ' ' + state + ' ' + zipcode;
                editDeliveryAddress = await validateAddress(addressText);
                const apt = aptTextField.value;
                editDeliveryAddress.apt = apt;
                await saveUpdateUserAddress(editDeliveryAddress);
            } catch (e) {
                alert('Invalid address' + e.message);
            }
            progressModal.style.display = 'none';
        } else alert(error);
    });
    function checkAddressInput(address, zipcode, city, state) {
        var error = '';
        if (state == '') error = 'State is required';
        if (city == '') error = 'City is required';
        if (zipcode.length != 5) error = 'Zipcode must be 5 digits';
        if (address == '') error = 'Address is required';
        return error;
    }
    async function saveUpdateUserAddress(addressObject) {
        const apt = aptTextField.value;
        const instructions = instructionsTextField.value;
        var request = {
            address: editDeliveryAddress.addressLabel,
            apt: apt,
            city: editDeliveryAddress.city,
            state: editDeliveryAddress.stateCode,
            zipcode: editDeliveryAddress.postalCode,
            instructions: instructions,
            saveaddress: true
        };
        if (existingAddress != null) request.addressid = existingAddress.id;
        try {
            await (0, $03cFT.default).Cloud.run('saveUserAddress', request);
            //goToNextPage('/settings');
            clearAddressTextFields();
            showDeliveryForm();
            addressModal.style.display = 'none';
        } catch (e) {
            alert(e.message);
        }
    }
    // MARK: - PICK UP FORM
    pickUpZipcodeField.addEventListener('input', (e)=>{
        const zipcodeText = e.target.value;
        if (zipcodeText.length > 5) e.target.value = zipcodeText.substring(0, 5);
    });
    pickUpFormButton.addEventListener('click', async ()=>{
        const zipcodeText = pickUpZipcodeField.value;
        if (zipcodeText.length == 5) {
            const verifyAddress = pickupAddressNeedsVerification(zipcodeText);
            if (verifyAddress) {
                progressModal.style.display = 'flex';
                try {
                    const address = await validateAddress(zipcodeText);
                    sessionStorage.setItem('pickupAddress', JSON.stringify(address));
                    (0, $cxph1.goToNextPage)('/locations');
                } catch (e) {
                    alert('Invalid address: ' + e.message);
                }
                progressModal.style.display = 'none';
            } else (0, $cxph1.goToNextPage)('/locations');
        } else alert('Zipcode requires 5 digits');
    });
    function pickupAddressNeedsVerification(zipcodeText) {
        var verifyAddress = true;
        const previousAddress = JSON.parse(sessionStorage.getItem('pickupAddress'));
        if (previousAddress != null) {
            const previousZipcode = previousAddress.postalCode;
            if (zipcodeText == previousZipcode) verifyAddress = false;
        }
        return verifyAddress;
    }
    setUpPage();
});


//# sourceMappingURL=order.4cb3510e.js.map
